import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import ProductAttributes from "../Components/ProductAttributes";
import SellerInfoCard from "../Components/SellerInfoCard";
import LoadingOverlay from "../Components/LoadingOverlay";
import "../assests/css/sellerDetails.css";

const API_BASE = "https://admin.bridge365.in/wp-json";

function SellerDetail() {
  const { sellerId } = useParams();

  const [seller, setSeller] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSellerData();
  }, [sellerId]);

  const loadSellerData = async () => {
    try {
      setLoading(true);

      const [sellerRes, productsRes] = await Promise.all([
        fetch(`${API_BASE}/custom/v1/seller/${sellerId}`),
        fetch(`${API_BASE}/custom/v1/seller-products/${sellerId}`),
      ]);

      const sellerData = await sellerRes.json();
      const productData = await productsRes.json();

      console.log("SELLER:", sellerData);
      console.log("PRODUCTS:", productData);

      setSeller(sellerData);
      setProducts(Array.isArray(productData) ? productData : []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <LoadingOverlay />;
  }

  if (!seller) {
    return <div className="seller-loading">Seller not found</div>;
  }

  return (
    <>
      <Header />

      <div className="seller-page">
        <div className="container">
          <div className="seller-breadcrumb">
            <Link to="/">Home</Link>
            <span> / </span>
            <span>{seller.shop_name}</span>
          </div>

          <div className="seller-layout">
            <aside className="seller-sidebar">
              <SellerInfoCard seller={seller} productCount={products.length} />

              <div className="seller-contact-card">
                <h3>Store Details</h3>

                <div className="seller-contact-info">
                  {seller.company_name && (
                    <div className="seller-row">
                      <strong>Company</strong>
                      <span>{seller.company_name}</span>
                    </div>
                  )}

                  {seller.phone && (
                    <div className="seller-row">
                      <strong>Phone</strong>
                      <span>{seller.phone}</span>
                    </div>
                  )}

                  {seller.gst_number && (
                    <div className="seller-row">
                      <strong>GST</strong>
                      <span>{seller.gst_number}</span>
                    </div>
                  )}
                </div>

                {seller.address && (
                  <div className="seller-address-card">
                    <h4>Store Address</h4>

                    <p>{seller.address.address1}</p>

                    {seller.address.address2 && (
                      <p>{seller.address.address2}</p>
                    )}

                    <p>
                      {seller.address.city}
                      {seller.address.state && `, ${seller.address.state}`}
                    </p>

                    <p>
                      {seller.address.country}
                      {seller.address.postcode && ` - ${seller.address.postcode}`}
                    </p>
                  </div>
                )}
              </div>
            </aside>

            <section className="seller-content">
             <div
  className="seller-banner"
  style={{
    backgroundImage: `url(${seller.banner})`
  }}
>
                <div className="seller-banner-overlay">
                  <h1>{seller.shop_name}</h1>

                  <p>
                    Seller Marketplace
                  </p>
                </div>
              </div>

              <div className="seller-products-header">
                <h2>Products ({products.length})</h2>
              </div>

              {/* DEBUG */}
              <pre style={{ display: "none" }}>
                {JSON.stringify(products[0], null, 2)}
              </pre>

              {products.length === 0 ? (
                <div className="empty-products">
                  No products found.
                </div>
              ) : (
                <div className="shop-products-grid">
                  {products.map((product, index) => (
                    <article
                      className="shop-product-card"
                      key={product.id || index}
                    >
                      <Link
                        className="shop-product-link"
                        to={`/product/${product.id}`}
                      >
                        <div className="shop-product-image-wrap">
                          <img
                            src={
                              product.image ||
                              product.images?.[0]?.src ||
                              "https://via.placeholder.com/300x300"
                            }
                            alt={product.name}
                            className="shop-product-image"
                          />
                        </div>

                        <h4 className="shop-product-title">
                          {product.name}
                        </h4>

                        <ProductAttributes
                          attributes={product.attributes}
                          className="product-attributes-compact"
                          limit={3}
                        />

                        <div className="shop-product-price">
                          ₹{product.price}
                        </div>
                      </Link>
                    </article>
                  ))}
                </div>
              )}
            </section>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default SellerDetail;
